import { Avatar, Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid2, IconButton, ListItemText, Menu, MenuItem, Paper, Select, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, Typography } from "@mui/material";
import TokenError from "../tokenError";
import { useEffect, useState } from "react";
import {makeGetRequestToUrl, makePostRequestToUrl} from '../commonFunc.jsx';
import config from '../../config/config.js';
import { useNavigate } from "react-router-dom";
import prevIcon from '../../assets/icons/left-arrow.svg';
import EmailIcon from '@mui/icons-material/Email';
import nextIcon from '../../assets/icons/right-arrow.svg';
import CloseIcon from '@mui/icons-material/Close';
import threeDots from '../../assets/images/threeDots.svg';
import { Label } from "flowbite-react";
import dayjs from 'dayjs';
import defaultImg from '../../assets/images/defaultimg.png';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import blueCarIcon from '../../assets/icons/blueCar.svg';
import blackSeatIcon from '../../assets/icons/blackSeat.svg';
import bagIcon from '../../assets/icons/Bag.svg';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import pickupIcon from '../../assets/icons/PickupIcon.svg';
import dropIcon from '../../assets/icons/DropIcon.svg';
import PhoneIcon from '@mui/icons-material/Phone';
import altProfile from '../../assets/images/altProfile.png';

var constants = require('../../constant.js');

const AtCancelledTrip = () => {
    const [tokenExpired, setTokenExpired] = useState(false);
    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const navigate = useNavigate();
    const cities = JSON.parse(localStorage.getItem('cities'));
    const [cityFilter, setCityFilter] = useState(cities[0].city_id);
    const [bookingModeFilter, setBookingModeFilter] = useState('');
    const [unfilteredRows, setUnfilteredRows] = useState([]);
    const [rows, setRows] = useState([]);
    const [order, setOrder] = useState('desc');
    const [orderBy, setOrderBy] = useState('pickup_time');
    const [page, setPage] = useState(0);
    const [rowsPerPage] = useState(10);
    const [errorMessage, setErrorMessage] = useState('');
        const [startDateFilter, setStartDateFilter] = useState(dayjs().startOf('month').startOf('day'));
        const [endDateFilter, setEndDateFilter] = useState(dayjs().endOf('month').startOf('day'));

    const [menuAnchorEl, setMenuAnchorEl] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);
    const [openDetails, setOpenDetails] = useState(false);
    const [openDeleteConfirmModal, setOpenDeleteConfirmModal] = useState(false);
    const [message, setMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);
    const client_id = localStorage.getItem('clientId');
    const ischange_point_to_comma = localStorage.getItem('change_point_to_comma');

    const bookingModeOptions = [
        { value: '', label: 'All Modes' },
        { value: '-1', label: 'Admin Panel' },
        { value: '1', label: 'PIU' },
        { value: '2', label: 'Transferz' },
        { value: '0', label: 'Others' },
    ];

    const handleBookingModeChange = (event) => {
        setBookingModeFilter(event.target.value);
    };

    const allowedFields = constants.TripFieldToShow[client_id] || constants.TripFieldToShow[1];

    const allHeaders = [
    'Booking ID',
    'Booking Mode',
    'Source ID',
    'User',
    'Driver',
    'Date & Time',
    'Vehicle Number',
    'Distance (in km)',
    'Duration (in min)',
    'Fare',
    'Tax',
    'Extras',
    'Partner Price',
    'Total Fare',
    'Status',
    'Parent Booking ID',
    'Journey Code',
    'Consent Form URL',
    'Action'
    ];

    const visibleHeaders = allowedFields && allowedFields.length > 0
    ? allHeaders.filter(header => allowedFields.includes(header))
    : allHeaders;
    

    const fetchAtCancelledTripsData = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/airport/fetch_bookings';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                status: 5,  //cancelled
                city_id: cityFilter,
                start_date: startDateFilter.format('YYYY-MM-DD'),
                end_date: endDateFilter.format('YYYY-MM-DD'),
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                // Sort data in descending order by pickup_time before setting to state
                const sortedData = response.data.sort((a, b) => {
                    return new Date(b.pickup_time) - new Date(a.pickup_time);
                });
                setUnfilteredRows(sortedData);
                // const formattedData = formatDataForCSV(sortedData);
                // setAllData(formattedData);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        }
        catch (error) {
            console.log('error', error);
        }
    };

    const handleRequestSort = (property) => {
        const isAscending = orderBy === property && order === 'asc';
        setOrder(isAscending ? 'desc' : 'asc');
        setOrderBy(property);
        const sortedRows = [...rows].sort((a, b) => {
            if (a[property] < b[property]) return isAscending ? -1 : 1;
            if (a[property] > b[property]) return isAscending ? 1 : -1;
            return 0;
        });
        setRows(sortedRows);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleCityChange = (e) =>{
        const city =  cities.find((cityObj) => cityObj.city_id === e)
        setCityFilter(e);
    }
    
    useEffect(()=> {
        fetchAtCancelledTripsData();
    },[cityFilter, startDateFilter, endDateFilter])

    useEffect(() => {
        if (!unfilteredRows) {
            setRows([]);
            return;
        }

        let processedRows = unfilteredRows;

        // Apply booking mode filter
        if (bookingModeFilter && bookingModeFilter !== '') {
            processedRows = processedRows.filter(row => String(row.source) === bookingModeFilter);
        }

        // Note: City, StartDate, EndDate filters are applied at API level for CancelledTrip
        // If they were meant to be client-side as well, that logic would go here.
        // For now, assuming API handles date/city, and only bookingMode is client-side post-fetch.

        setRows(processedRows);
    }, [unfilteredRows, bookingModeFilter]);

    const handleMenuOpen = (event, row) => {
        setMenuAnchorEl(event.currentTarget);
        setSelectedRow(row);
    };

    const formatNumber = (num) => {
        return num?.toString().replace('.', ',');
    };


    const handleMenuClose = () => {
        setMenuAnchorEl(null);
    };

    const openConfirmDialog = (action) => {
        handleMenuClose();
        if(action=='view') setOpenDetails(true);
        if(action=='delete') setOpenDeleteConfirmModal(true);
        // setSelectedRow(selectedRow);
    };
    const handleCloseDetails = () => {
        setOpenDetails(false);
    }
    const handleCloseDeleteConfirmModal = () => {
        setOpenDeleteConfirmModal(false);
    }

    const exportCSV = () => {
        const headers = [
            'Booking ID',
            'Booking Mode',
            'Source ID',
            'Customer Name',
            'Phone Number',
            'Email',
            'Company Name',
            'Pickup Address',
            'Drop Address',
            'Stops',
            'Pickup Time',
            'Number of Seats',
            'Number of Children',
            'Luggage Count',
            'Driver Name',
            'Driver Email',
            'Driver Phone Number',
            'Vehicle Number',
            'Distance',
            'Duration',
            'Price',
            'Tax',
            'Partner Price',
            'Extra Price',
            'Total Fare',
            'Payment Mode',
            'Payment Status',
            'Flight Number',
            'Journey Code',
            'Parent Booking ID',
            // 'Booking Status',
            'Driver Remarks',
            'Self Remarks'
        ];

        // Map the data rows to match the headers
        const csvData = rows.map(row => {
            const stopsString = row.way_points
            ? row.way_points
                .map((item, index) =>
                    (index !== 0 && index !== row.way_points.length - 1)
                        ? `${index}) ${item.address}`
                        : null
                )
                .filter(Boolean)
                .join('\n')
            : '';

            return [
                row.booking_id,
                row.source==1 ? 'PIU' : row.source==2 ? 'Transferz' : row.source==0 ? 'Others' : row.source==-1 ? 'Admin Panel' : 'Unknown',
                row.source_id,
                `${row.user_first_name || ''} ${row.user_last_name || ''}`,
                row.user_phone_number || '',
                row.user_email || '',
                row.user_company_name || '',
                row.pickup_address || '',
                row.drop_address || '',
                stopsString,
                dayjs(row.pickup_time).format('DD-MM-YYYY HH:mm') || '',
                row.ticket_count || '0',
                row.no_of_childrens || '0',
                row.luggage_count || '0',
                row.driver_name || '--',
                row.driver_email || '--',
                row.driver_phone || '--',
                row.vehicle_number || '--',
                row.distance || '0',
                row.duration || '0',
                row.fare || '0',
                row.tax || '0',
                row.partner_fare || '0',
                row.extra_fare || '0',
                (Number(row.fare) + Number(row.tax) + Number(row.partner_fare) + Number(row.extra_fare)) || '0',
                row.payment_mode==1 ? 'Cash' : row.payment_mode==2 ? 'Prepaid' : 'Unknown' || '',
                row.payment_status==0 ? 'Pending' : row.payment_status==1 ? 'Paid' : 'Unknown' || '',
                row.flight_number || '--',
                row.journey_code || '--',
                row.linked_booking_id || '--',
                // row.booking_status==1 ? 'Pending' : row.booking_status==2 ? 'Accepted' : row.booking_status==3 ? 'Rejected' : row.booking_status==4 ? 'Missed' : row.booking_status==5 ? 'Cancelled' : row.booking_status==6 ? 'Assigned' : 'Unknown',
                row.driver_remarks || '--',
                row.self_remarks || '--'
            ];
        });

        // Create CSV content
        let csvContent = headers.join(',') + '\n';
        
        csvData.forEach(rowArray => {
            const formattedRow = rowArray.map(field => {
                const stringField = String(field || '');
                if (stringField.includes(',') || stringField.includes('"') || stringField.includes('\n')) {
                    return `"${stringField.replace(/"/g, '""')}"`;  
                }
                return stringField;
            });
            csvContent += formattedRow.join(',') + '\n';
        });

        // Create a blob and download link
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        
        // Set up download attributes
        const date = new Date().toISOString().slice(0, 10);
        link.setAttribute('href', url);
        link.setAttribute('download', `cancelled_trips_${date}.csv`);
        link.style.visibility = 'hidden';
        
        // Append to document, trigger download, and clean up
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleDeleteBooking = async () => {
        const token = localStorage.getItem('token');
        const payload = {
            token: token,
            booking_id: selectedRow.booking_id,
            booking_status: -1,
        };
        try {
            const url = operationsUrl + '/airport/create_and_update_bookings';
            const response = await makePostRequestToUrl(url, payload);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);
                setOpenDeleteConfirmModal(false);
                fetchAtCancelledTripsData();
            }
            else if(response.flag==102){
                localStorage.removeItem('token');
                // setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);
                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            } else {
                setMessage(response.message)
                showSnackbar(true);
            }
        } catch (error) {
            console.error('Error', error);
            setMessage(error);
        }
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return; 
        }
        showSnackbar(false); 
    };

    return (
        <div>
            {tokenExpired && (<TokenError/>)}

            <Dialog
                open={openDeleteConfirmModal}
                onClose={() => setOpenDeleteConfirmModal(false)}
                aria-labelledby="delete-booking-dialog-title"
                aria-describedby="delete-booking-dialog-description"
                PaperProps={{
                    style: {
                        borderRadius: '12px',
                        padding: '10px'
                    }
                }}
            >
                <DialogTitle id="delete-booking-dialog-title" sx={{fontWeight:'bold'}}>Confirm Deletion</DialogTitle>
                <DialogContent>
                    <DialogContentText id="delete-booking-dialog-description">
                        Are you sure you want to delete this booking permanently?
                        <br/> This cannot be undone.
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{paddingBottom:'20px', paddingRight:'20px'}}>
                    <Button 
                        onClick={() => setOpenDeleteConfirmModal(false)} 
                        sx={{
                            color: '#6B7280', 
                            borderRadius:'8px', 
                            textTransform:'none',
                            border: '1px solid #D1D5DB',
                            '&:hover': {
                                backgroundColor: '#F3F4F6',
                                borderColor: '#9CA3AF'
                            }
                        }}
                    >
                        No
                    </Button>
                    <Button 
                        onClick={() => {
                            handleDeleteBooking();
                            setOpenDeleteConfirmModal(false);
                        }} 
                        color="error"
                        variant="contained"
                        sx={{ 
                            backgroundColor: '#EF4444', 
                            borderRadius:'8px', 
                            textTransform:'none',
                            '&:hover': {
                                backgroundColor: '#DC2626'
                            }
                        }}
                        autoFocus
                    >
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>

            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>
                Cancelled Trips
            </Typography>

            <Grid2 container alignItems="center" style={{ marginBottom: '1%', alignItems:'center' }}>
                <Grid2 item>
                    <Label></Label><br/>
                    <Select value={cityFilter} 
                    onChange={(e) => handleCityChange(e.target.value)} displayEmpty
                    style={{width: '190px',height:'40px', marginTop:'0px',borderRadius:'8px',backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF'}}>
                        <MenuItem value="">Select City</MenuItem>
                        {cities.map((city) => (
                            <MenuItem key={city.city_name} value={city.city_id}>
                                {city.city_name}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid2>

                <Grid2 item sx={{marginLeft:'2%'}}>
                    <Label></Label><br/>
                    <Select value={bookingModeFilter}
                        onChange={handleBookingModeChange} displayEmpty
                        style={{width: '190px',height:'40px', marginTop:'0px', borderRadius:'8px', backgroundColor: bookingModeFilter ? '#F9F9F9' : '#FFFFFF'}}>
                        {bookingModeOptions.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid2>
                
                <Grid2 item sx={{marginLeft:'2%'}}>
                    <Label>Start Date:</Label><br/>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            format="DD/MM/YYYY"
                            slotProps={{ 
                                textField: { 
                                    size: 'small',
                                    error: endDateFilter && startDateFilter && startDateFilter.isAfter(endDateFilter)
                                } 
                            }}
                            sx={{
                                width: '190px',
                                '& .MuiInputBase-root': {
                                    height: '40px',
                                    borderRadius: '8px',
                                    backgroundColor: '#FFFFFF',
                                    marginTop:'4px'
                                }
                            }}
                            value={startDateFilter}
                            onChange={(newValue) => {
                                if (endDateFilter && newValue && newValue.isAfter(endDateFilter)) {
                                    setEndDateFilter(null);
                                }
                                setStartDateFilter(newValue);
                            }}
                            maxDate={endDateFilter || undefined}
                        />
                    </LocalizationProvider>
                </Grid2>

                <Grid2 item sx={{marginLeft:'2%'}}>
                    <Label>End Date:</Label><br/>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            format="DD/MM/YYYY"
                            slotProps={{ 
                                textField: { 
                                    size: 'small',
                                    error: endDateFilter && startDateFilter && startDateFilter.isAfter(endDateFilter)
                                } 
                            }}
                            sx={{
                                width: '190px',
                                '& .MuiInputBase-root': {
                                    height: '40px',
                                    borderRadius: '8px',
                                    backgroundColor: '#FFFFFF',
                                    marginTop:'4px'
                                }
                            }}
                            value={endDateFilter}
                            onChange={(newValue) => setEndDateFilter(newValue)}
                            minDate={startDateFilter || undefined}
                        />
                    </LocalizationProvider>
                </Grid2>

                <Grid2 item sx={{marginLeft:'1%', marginLeft:'auto'}}>
                    <Label></Label><br/>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={exportCSV}
                        sx={{
                            height: '40px',
                            textTransform: 'none',
                            borderRadius: '8px',
                            backgroundColor: '#36C68F',
                            '&:hover': {
                                backgroundColor: '#36C68F',
                            },
                        }}
                    >
                        Export CSV
                    </Button>
                </Grid2>
            </Grid2>

            <div
                style={{
                    position: 'fixed',
                    top: 65,
                    right: openDetails ? 0 : '-100%',
                    height: '100%',
                    width: '50%',
                    backgroundColor: '#f9f9f9',
                    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
                    transition: 'right 0.3s ease-in-out',
                    zIndex: 1000,
                    overflowY: 'auto',
                    padding: 20
                }}
            >
                <Box onClose={handleCloseDetails}>
                    <div style={{ position: 'relative', padding: '40px 0' }}>
                        {/* Close Button Outside the Card */}
                        <IconButton
                            aria-label="close"
                            onClick={handleCloseDetails}
                            style={{
                                position: 'absolute',
                                top: '-15px', // Position it above the Paper component
                                left: '1px',
                                color: '#333',
                                zIndex: 10,
                            }}
                        >
                            <CloseIcon style={{ fontSize: '32px', fontWeight: 'bold' }} />
                        </IconButton>
                        <Box sx={{ 
                                maxWidth: '800px', 
                                margin: '0 auto',
                                position: 'relative',
                                marginBottom: '20px',
                                boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)'
                            }}>
                            <Paper
                                elevation={0}
                                style={{ 
                                    padding: '30px', 
                                    backgroundColor: '#FFFFFF', 
                                    borderRadius: '12px',
                                    border: '1px solid #E0E0E0',
                                    position: 'relative'
                                }}>
                            <Typography style={{ marginBottom: '10px', fontWeight: '500', fontSize:'24px' }}>
                                Booking Details
                            </Typography>
                            <hr/>

                            <Grid2 container spacing={2}>
                                <Grid2 item>
                                    <Button variant="contained" sx={{backgroundColor:'#0065ff', borderRadius:'8px', textTransform:'none'}}>Booking ID: {selectedRow?.booking_id}</Button>
                                </Grid2>
                                <Grid2 item sx={{border: '1px solid #C71F1F', borderRadius:'8px', padding:'6px 12px', backgroundColor:'#FFF5F5'}}>
                                    <Typography sx={{color:'#C71F1F'}}>Cancelled</Typography>
                                </Grid2>
                            </Grid2>

                            <Grid2>
                                <Typography sx={{fontSize:'20px', fontWeight:'500', marginTop:'20px'}}>User Details</Typography>

                                <Grid2 container spacing={2} sx={{ marginTop:'16px', alignItems:'center', marginBottom:'16px'}} size={12}>
                                    <Grid2 item size={3.5}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>User Name</Typography>
                                        <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                            {selectedRow?.user_image ? <Avatar
                                                sx={{ borderColor: "#0065FF", border: 1, marginRight:'8px' }}
                                                alt="John Doe"
                                                src={selectedRow?.user_image}
                                            ></Avatar> : <Avatar sx={{ borderColor: "#0065FF", border: 1, marginRight:'8px' }} alt='name' src={altProfile}></Avatar>
                                            }
                                            <Typography>{selectedRow?.user_first_name + ' ' + selectedRow?.user_last_name}</Typography>
                                        </Grid2>
                                    </Grid2>
                                    <Grid2 item size={5}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Email ID</Typography>
                                        <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                            <EmailIcon sx={{marginRight:'8px'}}/>
                                            <Typography>{selectedRow?.user_email}</Typography>
                                        </Grid2>
                                    </Grid2>
                                    <Grid2 item size={3.5}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Phone Number</Typography>
                                        <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                            <PhoneIcon sx={{marginRight:'8px'}}/>
                                            <Typography>{selectedRow?.user_phone_number}</Typography>
                                        </Grid2>
                                    </Grid2>
                                    <Grid2 item size={3.5}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Company Name</Typography>
                                        <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                            <Typography>{selectedRow?.user_company_name ? selectedRow?.user_company_name : '--'}</Typography>
                                        </Grid2>
                                    </Grid2>
                                    <Grid2 item size={5}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>No. of Seats</Typography>
                                        <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                            <img src={blackSeatIcon} alt="blackSeatIcon"/>
                                            <Typography sx={{marginLeft:'8px'}}>{selectedRow?.ticket_count}</Typography>
                                        </Grid2>
                                    </Grid2>
                                    <Grid2 item size={3}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>No. of Children</Typography>
                                        <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                            <Typography>{selectedRow?.no_of_childrens ? selectedRow?.no_of_childrens : '0'}</Typography>
                                        </Grid2>
                                    </Grid2>
                                    <Grid2 item size={3}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Luggage</Typography>
                                        <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                            <img src={bagIcon} alt="bagIcon"/>
                                            <Typography sx={{marginLeft:'8px'}}>{selectedRow?.luggage_count}</Typography>
                                        </Grid2>
                                    </Grid2>
                                </Grid2>

                                <hr/>
                                <Typography sx={{fontSize:'20px', fontWeight:'500', marginTop:'20px'}}>Driver Details</Typography>
                                <Grid2 container spacing={2} sx={{ marginTop:'16px', alignItems:'center', marginBottom:'16px'}} size={12}>
                                    <Grid2 item size={3.5}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Driver Name</Typography>
                                        <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                            <Avatar
                                                sx={{ borderColor: "#0065FF", border: 1, marginRight:'8px' }}
                                                alt="John Doe"
                                                src={selectedRow?.driver_image}
                                            ></Avatar>
                                            <Typography>{selectedRow?.driver_name ? selectedRow?.driver_name : '--'}</Typography>
                                        </Grid2>
                                    </Grid2>
                                    <Grid2 item size={5}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Email ID</Typography>
                                        <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                            <EmailIcon sx={{marginRight:'8px'}}/>
                                            <Typography>{selectedRow?.driver_email ? selectedRow?.driver_email : '--'}</Typography>
                                        </Grid2>
                                    </Grid2>
                                    <Grid2 item size={3.5}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Phone Number</Typography>
                                        <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                            <PhoneIcon sx={{marginRight:'8px'}}/>
                                            <Typography>{selectedRow?.driver_phone ? selectedRow?.driver_phone : '--'}</Typography>
                                        </Grid2>
                                    </Grid2>
                                </Grid2>

                                <hr/>
                                <Typography sx={{fontSize:'20px', fontWeight:'500', marginTop:'20px'}}>Vehicle Details</Typography>
                                <Grid2 container spacing={2} sx={{ marginTop:'16px', alignItems:'center', marginBottom:'16px'}} size={12}>
                                    <Grid2 item size={2.4}>
                                        <img src={blueCarIcon} alt="blueCarIcon"/>
                                    </Grid2>
                                    {/* <Grid2 item size={3.2}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Vehicle Name</Typography>
                                        <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                            <Typography>Nissan</Typography>
                                        </Grid2>
                                    </Grid2> */}
                                    <Grid2 item size={3.2}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Vehicle Category</Typography>
                                        <Typography>{selectedRow?.vehicle_category ? selectedRow?.vehicle_category : '--'}</Typography>
                                    </Grid2>
                                    <Grid2 item size={3.2}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Vehicle Number</Typography>
                                        <Typography>{selectedRow?.vehicle_number ? selectedRow?.vehicle_number : '--'}</Typography>
                                    </Grid2>
                                </Grid2>

                                <hr/>
                                <Typography sx={{fontSize:'20px', fontWeight:'500', marginTop:'12px'}}>Booking Details</Typography>
                                <Grid2 container spacing={2} sx={{ marginTop:'8px', alignItems:'center', marginBottom:'16px'}} size={12}>
                                    <Grid2 item size={4}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Booking Mode</Typography>
                                        <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                            <Typography sx={{ minWidth: '100px', color: selectedRow?.source==1 ? '#0C3B7C' : selectedRow?.source==2 ? '#AC8312' : selectedRow?.source==0 ? '#2B7FFF' : selectedRow?.source==-1 ? '#0065FF' : '#0065FF' }}>{selectedRow?.source==1 ? 'PIU' : selectedRow?.source==2 ? 'Transferz' : selectedRow?.source==0 ? 'Others' : selectedRow?.source==-1 ? 'Admin Panel' : 'Unknown'}</Typography>
                                            
                                        </Grid2>
                                    </Grid2>
                                    <Grid2 item size={4}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Source ID</Typography>
                                        <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                            <Typography>{selectedRow?.source_id}</Typography>
                                        </Grid2>
                                    </Grid2>
                                    <Grid2 item size={4}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Date & Time</Typography>
                                        <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                            <AccessTimeFilledIcon sx={{marginRight:'8px'}}/>
                                            <Typography>{selectedRow?.pickup_time ? new Date(selectedRow?.pickup_time).toLocaleString('en-GB', {day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true}).replace(',', ' |') : ''}</Typography>
                                        </Grid2>
                                    </Grid2>
                                </Grid2>

                                <Grid2 container spacing={2} sx={{ marginTop:'8px', alignItems:'center', marginBottom:'16px'}} size={12}>
                                    <Grid2 item size={4}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Parent Booking ID</Typography>
                                        <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                            <Typography>{selectedRow?.linked_booking_id}</Typography>
                                        </Grid2>
                                    </Grid2>
                                    <Grid2 item size={4}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Journey Code</Typography>
                                        <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                            <Typography>{selectedRow?.journey_code ? selectedRow?.journey_code : '--'}</Typography>
                                        </Grid2>
                                    </Grid2>
                                </Grid2>

                                <hr/>
                                <Typography sx={{fontSize:'20px', fontWeight:'500', marginTop:'12px'}}>Route Details</Typography>
                                                                
                                <Grid2 item>
                                    <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'3%'}}>
                                        <img height="22px" width="22px" src={pickupIcon}/>
                                        <Typography sx={{marginLeft:'1%'}}>{selectedRow?.pickup_address}</Typography>
                                    </Grid2>
                                </Grid2>
                                <hr style={{border: 'none', borderTop: '1px dotted #E3E5E8'}}/>
                                <Grid2 item>
                                    <Grid2>
                                        {selectedRow?.way_points?.map((item, index) => (
                                            <>
                                                <div key={index}>
                                                    {(index!=0 && index!=selectedRow?.way_points.length-1) && 
                                                        (
                                                            <>
                                                            <Grid2 sx={{ marginTop:'2%',display:'flex', alignItems:'center'}}>
                                                                <span style={{
                                                                    display: 'inline-block',
                                                                    minWidth: 20,
                                                                    minHeight: 20,
                                                                    borderRadius: '50%',
                                                                    background: '#2A313C',
                                                                    color: '#fff',
                                                                    fontWeight: 500,
                                                                    textAlign: 'center',
                                                                    lineHeight: '20px',
                                                                    marginRight: 8
                                                                }}>{index}</span>
                                                                <Typography>{item.address}</Typography>
                                                                
                                                            </Grid2>
                                                            <hr style={{border: 'none', borderTop: '1px dotted #E3E5E8'}}/>
                                                            </>
                                                        )
                                                    }
                                                </div>
                                            </>
                                        ))}
                                    </Grid2>
                                </Grid2>
                                <Grid2 item>
                                    <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'2%', marginBottom:'16px'}}>
                                        <img height="22px" width="22px" src={dropIcon}/>
                                        <Typography sx={{marginLeft:'1%'}}>{selectedRow?.drop_address}</Typography>
                                    </Grid2>
                                </Grid2>

                                <Grid2 container spacing={2} sx={{ marginTop:'8px', alignItems:'center', marginBottom:'16px'}} size={12}>
                                    <Grid2 item size={4}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Distance (in km)</Typography>
                                        <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                            <Typography>{ischange_point_to_comma == '1' ?formatNumber(selectedRow?.distance) : (selectedRow?.distance)}</Typography>
                                            
                                        </Grid2>
                                    </Grid2>
                                    <Grid2 item size={4}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Duration (in minutes)</Typography>
                                        <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                            <Typography>{selectedRow?.duration}</Typography>
                                            
                                        </Grid2>
                                    </Grid2>
                                </Grid2>

                                <hr/>
                                <Typography sx={{fontSize:'20px', fontWeight:'500', marginTop:'12px'}}>Flight Details</Typography>
                                <Grid2 container spacing={2} sx={{ marginTop:'8px', alignItems:'center', marginBottom:'16px'}} size={12}>
                                    <Grid2 item size={6}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Flight Number</Typography>
                                        <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                            <Typography>{selectedRow?.flight_number || '--'}</Typography>
                                        </Grid2>
                                    </Grid2>
                                </Grid2>

                                <hr/>
                                <Typography sx={{fontSize:'20px', fontWeight:'500', marginTop:'12px'}}>Payment Details</Typography>
                                <Grid2 container spacing={2} sx={{ marginTop:'8px', alignItems:'center', marginBottom:'16px'}} size={12}>
                                    <Grid2 item size={4}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Fare</Typography>
                                        <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                            <Typography>€{ischange_point_to_comma == '1' ? formatNumber(selectedRow?.fare):(selectedRow?.fare) || '0'}</Typography>
                                        </Grid2>
                                    </Grid2>
                                    <Grid2 item size={4}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Tax</Typography>
                                        <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                            <Typography>€{ischange_point_to_comma == '1' ? formatNumber(selectedRow?.tax):(selectedRow?.tax) || '0'}</Typography>
                                        </Grid2>
                                    </Grid2>
                                    <Grid2 item size={4}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Partner Price</Typography>
                                        <Typography>€{ischange_point_to_comma == '1' ? formatNumber(selectedRow?.partner_fare) : (selectedRow?.partner_fare) || '0'}</Typography>
                                    </Grid2>
                                </Grid2>

                                <Grid2 container spacing={2} sx={{ marginTop:'8px', alignItems:'center', marginBottom:'16px'}} size={12}>
                                    <Grid2 item size={4}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Extras</Typography>
                                        <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                            <Typography>€{ischange_point_to_comma == '1' ? formatNumber(selectedRow?.extra_fare) : (selectedRow?.extra_fare)|| '0'}</Typography>
                                        </Grid2>
                                    </Grid2>
                                    <Grid2 item size={4}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Total Fare</Typography>
                                        <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                            <Typography sx={{color:'#0065ff'}}>€{ischange_point_to_comma == '1' ? formatNumber(Number(selectedRow?.fare) + Number(selectedRow?.extra_fare) + Number(selectedRow?.tax) + Number(selectedRow?.partner_fare)) : (Number(selectedRow?.fare) + Number(selectedRow?.extra_fare) + Number(selectedRow?.tax) + Number(selectedRow?.partner_fare))}</Typography>
                                        </Grid2>
                                    </Grid2>
                                    <Grid2 item size={4}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Payment Status</Typography>
                                        <Typography sx={{color:selectedRow?.payment_status==1 ? '#0DBA78' : '#AC8312'}}>{selectedRow?.payment_status==1 ? 'Paid' : selectedRow?.payment_status==0 ? 'Pending' : 'Unknown'}</Typography>
                                    </Grid2>
                                </Grid2>
                                <Grid2 item>
                                    <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Payment Mode</Typography>
                                    <Typography>{selectedRow?.payment_mode==1 ? 'Cash' : selectedRow?.payment_mode==2 ? 'Prepaid' : 'Unknown'}</Typography>
                                </Grid2>

                                <hr/>
                                <Typography sx={{fontSize:'20px', fontWeight:'500', marginTop:'12px'}}>Remarks</Typography>
                                <Grid2 container spacing={2} sx={{ marginTop:'8px', alignItems:'center', marginBottom:'16px'}} size={12}>
                                    <Grid2 item size={6}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Driver Remarks</Typography>
                                        <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                            <Typography>{selectedRow?.driver_remarks || '--'}</Typography>
                                        </Grid2>
                                    </Grid2>
                                    <Grid2 item size={6}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Self Remarks</Typography>
                                        <Typography>{selectedRow?.self_remarks || '--'}</Typography>
                                    </Grid2>
                                </Grid2>
                            </Grid2>

                        </Paper>
                        <div 
                            style={{
                                height: '10px',
                                backgroundColor: '#0065FF',
                                borderRadius: '0 0 12px 12px',
                                marginTop: '-1px',
                                position: 'relative',
                                zIndex: 1
                            }}
                        />
                        </Box>

                    </div>
                </Box>
            </div>

            <TableContainer className="table-container" sx={{maxHeight:'70vh'}}>
                <Table stickyHeader className="scrollable-table">
                    <TableHead>
                        {visibleHeaders.map(header => {
                            let sortKey = '';
                            switch (header) {
                                case 'Booking ID': sortKey = 'booking_id'; break;
                                case 'Booking Mode': sortKey = 'source'; break;
                                case 'Source ID': sortKey = 'source_id'; break;
                                case 'User': sortKey = 'user_first_name'; break;
                                case 'Driver': sortKey = 'driver_name'; break;
                                case 'Date & Time': sortKey = 'pickup_time'; break;
                                case 'Vehicle Number': sortKey = 'vehicle_number'; break;
                                case 'Distance (in km)': sortKey = 'distance'; break;
                                case 'Duration (in min)': sortKey = 'duration'; break;
                                case 'Fare': sortKey = 'fare'; break;
                                case 'Tax': sortKey = 'tax'; break;
                                case 'Extras': sortKey = 'extra_fare'; break;
                                case 'Partner Price': sortKey = 'partner_fare'; break;
                                case 'Total Fare': sortKey = 'total_fare'; break; // If you want to sort by computed total
                                case 'Payment Status': sortKey = 'payment_status'; break;
                                case 'Payment Mode': sortKey = 'payment_mode'; break;
                                case 'Status': sortKey = 'status'; break;
                                case 'Parent Booking ID': sortKey = 'linked_booking_id'; break;
                                case 'Journey Code': sortKey = 'journey_code'; break;
                                default: sortKey = ''; break;
                            }

                            // Only show TableSortLabel if sortable
                            if (sortKey) {
                                return (
                                <TableCell align="center" className="table-header" style={{ width: '15%' }} key={header}>
                                    <TableSortLabel
                                    active={orderBy === sortKey}
                                    direction={orderBy === sortKey ? order : 'asc'}
                                    onClick={() => handleRequestSort(sortKey)}
                                    >
                                    {header}
                                    </TableSortLabel>
                                </TableCell>
                                );
                            } else {
                                // For non-sortable columns like "Action"
                                return (
                                <TableCell align="center" className="table-header" style={{ width: '15%' }} key={header}>
                                    {header}
                                </TableCell>
                                );
                            }
                            })}
                    </TableHead>

                    <TableBody>
                        {rows.length === 0 && (
                            <TableRow>
                                <TableCell colSpan={16} align="center">
                                    <Typography variant="body1">No data found</Typography>
                                </TableCell>
                            </TableRow>
                        )}
                        {(rowsPerPage > 0
                            ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            : rows
                        ).map((row) => {

                            return(
                                <TableRow key={row.tms_client_id}>
                                    {visibleHeaders.map(header => {
                                switch (header) {
                                case 'Booking ID':
                                    return <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.booking_id}</Typography></TableCell>;
                                case 'Booking Mode':
                                return <TableCell align="center">
                                        <Typography sx={{ minWidth: '100px', color: row.source==1 ? '#0C3B7C' : row.source==2 ? '#AC8312' : row.source==0 ? '#8f8c81' : row.source==-1 ? '#0065FF' : '#0065FF' }}>{row.source==1 ? 'PIU' : row.source==2 ? 'Transferz' : row.source==0 ? 'Others' : row.source==-1 ? 'Admin Panel' : 'Unknown'}</Typography>
                                    </TableCell>;
                                case 'Source ID':
                                return <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.source_id ? row.source_id : '--'}</Typography></TableCell>;
                                case 'User':
                                return <TableCell align="center">
                                        <Grid2 container sx={{ width: "auto", minWidth: "180px" }}>
                                            <Grid2>
                                                {row.user_image && <Avatar sx={{ borderColor: "#0065FF", border: 1 }} alt='name' src={row.user_image}></Avatar>
                                                }
                                                {!row.user_image && <Avatar sx={{ borderColor: "#0065FF", border: 1 }} alt='name' src={altProfile}></Avatar>
                                                }
                                            </Grid2>
                                            <Grid2 item sx={{ ml: "8px", textAlign: "left" }}>
                                                <Grid2><Typography>{row.user_first_name + ' ' + row.user_last_name}</Typography></Grid2>
                                                <Grid2><Typography sx={{ color: "#83888E", fontSize: "12px" }}>{row.user_phone_number}</Typography></Grid2>
                                            </Grid2>
                                        </Grid2>
                                    </TableCell>;
                                case 'Driver':
                                return <TableCell align="center">
                                        {row.driver_name && 
                                            <Grid2 container sx={{ width: "auto", minWidth: "180px" }}>
                                                <Grid2>
                                                    {row.driver_image && <Avatar sx={{ borderColor: "#0065FF", border: 1 }} alt='name' src={row.driver_image}></Avatar>
                                                    }
                                                    {!row.driver_image && <Avatar sx={{ borderColor: "#0065FF", border: 1 }} alt='name' src={altProfile}></Avatar>
                                                    }
                                                </Grid2>
                                                <Grid2 item sx={{ ml: "8px", textAlign: "left" }}>
                                                    <Grid2><Typography>{row.driver_name}</Typography></Grid2>
                                                    <Grid2><Typography sx={{ color: "#83888E", fontSize: "12px" }}>{row.driver_phone}</Typography></Grid2>
                                                </Grid2>
                                            </Grid2>
                                        }
                                        {!row.driver_name && <Typography sx={{ width: 'auto', minWidth: '100px' }}>--</Typography>}
                                    </TableCell>;
                                case 'Date & Time':
                                return <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.pickup_time ? new Date(row.pickup_time).toLocaleString('en-GB', {day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true}).replace(',', ' |') : '--'}</Typography></TableCell>;
                                case 'Vehicle Number':
                                return <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.vehicle_number ? row.vehicle_number : '--'}</Typography></TableCell>;
                                case 'Distance (in km)':
                                return <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{ischange_point_to_comma == '1' ? formatNumber(row.distance) :(row.distance)}</Typography></TableCell>;
                                case 'Duration (in min)':
                                return <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px'}}>{row.duration}</Typography></TableCell>;
                                case 'Fare':
                                return <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>€ {ischange_point_to_comma == '1' ?formatNumber(row.fare) : (row.fare)}</Typography></TableCell>;
                                case 'Tax':
                                return ( <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{'€' + (ischange_point_to_comma == '1' ? formatNumber(row.tax) : row.tax)}</Typography></TableCell>)
                                case 'Extras':
                                return ( <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{'€' + (ischange_point_to_comma == '1' ? formatNumber(row.extra_fare) : row.extra_fare)}</Typography></TableCell>)
                                case 'Partner Price':
                                return ( <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{'€' + (ischange_point_to_comma == '1' ? formatNumber(row.partner_fare) : row.partner_fare)}</Typography></TableCell>)
                                case 'Total Fare':
                                return (<TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', color:'#0065FF' }}>{ '€' + (ischange_point_to_comma == '1' ? formatNumber(Number(row.fare) + Number(row.tax) + Number(row.extra_fare) + Number(row.partner_fare)) : (Number(row.fare) + Number(row.tax) + Number(row.extra_fare) + Number(row.partner_fare))  )}</Typography></TableCell>);
                                case 'Status':
                                return <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', color:'#C71F1F' }}>Cancelled</Typography></TableCell>;
                                case 'Parent Booking ID':
                                return <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.linked_booking_id==0 ? '--' : row.linked_booking_id}</Typography></TableCell>;
                                case 'Journey Code':
                                return <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.journey_code ? row.journey_code : '--'}</Typography></TableCell>;
                                case 'Consent Form URL':
                                return <TableCell align="center">
                                        {row.consent_form_url && <Button size="small" onClick={() => window.open(row.consent_form_url, '_blank')}>View</Button>}
                                        {!row.consent_form_url && <Typography>--</Typography>}
                                    </TableCell>;
                                    
                                case 'Action':
                                return <TableCell align="center">
                                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            <IconButton
                                                aria-label="more options" 
                                                size="small"
                                                onClick={(e) => handleMenuOpen(e, row)}
                                                sx={{ marginLeft: '4px' }}
                                            >
                                                {/* <MoreVertIcon /> */}
                                                <img src={threeDots} alt="threeDots"/>
                                            </IconButton>
                                        </Box>
                                        
                                        <Menu
                                            anchorEl={menuAnchorEl}
                                            open={Boolean(menuAnchorEl) && selectedRow?.tms_client_id === row.tms_client_id}
                                            onClose={handleMenuClose}
                                            PaperProps={{
                                                elevation: 3,
                                                sx: {
                                                    borderRadius: '8px',
                                                    minWidth: '160px',
                                                    padding: '4px 0',
                                                    overflow: 'visible',
                                                    '&:before': {
                                                        content: '""',
                                                        display: 'block',
                                                        position: 'absolute',
                                                        top: 0,
                                                        right: 14,
                                                        width: 10,
                                                        height: 10,
                                                        bgcolor: 'background.paper',
                                                        transform: 'translateY(-50%) rotate(45deg)',
                                                        zIndex: 0,
                                                    },
                                                },
                                            }}
                                            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                                            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                                        >
                                            <MenuItem onClick={() => openConfirmDialog('view')} sx={{ py: 1 }}>
                                                <ListItemText primary="View Details" sx={{ color: '#6B7280' }} />
                                            </MenuItem>
                                            <MenuItem onClick={() => openConfirmDialog('delete')} sx={{ py: 1 }}>
                                                <ListItemText primary="Delete Trip" sx={{ color: '#D14545' }} />
                                            </MenuItem>
                                        </Menu>
                                    </TableCell>;
                                    default:
                                                                    return <TableCell align="center" key={header}></TableCell>;
                                                                }
                                                            })}
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
                <div className="custom-pagination">
                    <div className="pagination-info">
                        {`Showing ${page * rowsPerPage + 1} to ${Math.min(
                            (page + 1) * rowsPerPage,
                            rows.length
                        )} of ${rows.length} entries`}
                    </div>
                    <div className="pagination-controls">
                        <button
                            onClick={() => handleChangePage(null, page - 1)}
                            disabled={page === 0}
                            className="pagination-arrow"
                        >
                            <img src={prevIcon} alt="Previous" />
                        </button>
                        <div className="pagination-numbers">
                            {[...Array(Math.ceil(rows.length / rowsPerPage))].map((_, index) => (
                                <button key={index} onClick={() => handleChangePage(null, index)}
                                    className={`pagination-number ${page === index ? 'active' : ''}`}>
                                    {index + 1}
                                </button>
                            ))}
                        </div>
                        <button
                            onClick={() => handleChangePage(null, page + 1)}
                            disabled={page >= Math.ceil(rows.length / rowsPerPage) - 1}
                            className="pagination-arrow"
                        >
                            <img src={nextIcon} alt="Next" />
                        </button>
                    </div>
                </div>
            </TableContainer>

            <Snackbar open={snackbar} autoHideDuration={2000} onClose={handleSnackbarClose} message={message}></Snackbar>
            
        </div>
    );
};

export default AtCancelledTrip;